import { expVal } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

const resolvedPackages = new Map<string, boolean>();

export function isRelayEnabled(callerPackage?: string): boolean {
	// Full Relay build — everything uses Relay
	if (process.env.BUILD_VARIANT === 'relay') return true;

	// No package specified — use global switch (backward compat)
	if (!callerPackage) {
		return expVal('confluence_apollo_to_relay_migration', 'isEnabled', false);
	}

	// Per-package check with memoization (stable for entire page lifecycle)
	if (!resolvedPackages.has(callerPackage)) {
		if (expVal('confluence_apollo_to_relay_migration', 'isEnabled', false)) {
			// Global switch overrides per-package
			resolvedPackages.set(callerPackage, true);
		} else {
			const packages = StatsigConfigurations.getStringList('confluence_relay_enabled_packages', []);
			resolvedPackages.set(callerPackage, packages.includes(callerPackage));
		}
	}

	return resolvedPackages.get(callerPackage)!;
}
